import AppContext from 'App/AppContext';
import { IPFontIcon, IPTooltipHost } from 'baseComponents';
import { copyIcon, validIcon } from 'globalStyles';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { htmlToText } from 'utils/html';

interface ICopyTextProps {
  text?: string | undefined;
  html?: string | undefined;
  left?: string | number | undefined;
  top?: string | number | undefined;
  color?: string | undefined;
  tooltip?: string | undefined;
}

const CopyText = (props: ICopyTextProps) => {
  const appContext = useContext(AppContext);
  const { t } = useTranslation('translation');
  const [copied, setCopied] = React.useState<boolean>(false);
  const [timer, setTimer] = React.useState<NodeJS.Timeout | undefined>(undefined);

  React.useEffect(() => {
    return () => {
      if (timer) clearTimeout(timer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const copyText = async () => {
    try {
      if (props.html) {
        const txt = htmlToText(props.html) || '';
        const blobHtml = new Blob([props.html], { type: 'text/html' });
        const blobText = new Blob([txt], { type: 'text/plain' });
        const data = [
          new ClipboardItem({
            'text/plain': blobText,
            'text/html': blobHtml,
          }),
        ];

        await navigator.clipboard.write(data);
      } else {
        await navigator.clipboard.writeText(props.text || '');
      }

      setCopied(true);
      setTimer(setTimeout(() => setCopied(false), 2000));
    } catch {
      appContext.showNotification(t('translation:CopyText.Error'), true);
    }
  };

  return (
    <IPTooltipHost
      content={props.tooltip || t('translation:CopyText.Tooltip')}
      styles={{
        root: {
          selectors: {
            '&:hover': {
              cursor: 'pointer',
            },
          },
        },
      }}
    >
      {!copied && (
        <IPFontIcon
          {...copyIcon}
          onClick={copyText}
          style={{ left: props.left, top: props.top, padding: 0, margin: 0, color: props.color }}
        ></IPFontIcon>
      )}
      {copied && (
        <IPFontIcon
          {...validIcon}
          style={{ left: props.left, top: props.top, padding: 0, margin: 0, color: props.color }}
        ></IPFontIcon>
      )}
    </IPTooltipHost>
  );
};

export default CopyText;
